import { useState } from 'react'

export const useHandleFileUpload = () => {
  const [files, setFiles] = useState<File[]>([])

  const allowedExtensions = ['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png']
  const allowedMimeTypes = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'image/jpeg',
    'image/png'
  ]

  const addFile = () => {
    const input = document.createElement('input')
    input.type = 'file'
    input.accept = allowedExtensions.join(',')
    input.multiple = true

    input.onchange = (e) => {
      const files = (e.target as HTMLInputElement).files
      if (!files) return

      const acceptedFiles = Array.from(files).filter((file) => allowedMimeTypes.includes(file.type))

      setFiles((prev) => [...prev, ...acceptedFiles])
    }

    input.click()
  }

  const removeFile = (index: number) => {
    setFiles((prev) => prev.filter((_, i) => i !== index))
  }

  return {
    files,
    setFiles,
    addFile,
    removeFile
  }
}
